import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  containerClassName: PropTypes.string,
};

const defaultProps = {
  containerClassName: '',
};

const CaptchaDisclaimer = ({ containerClassName }) => (
  <div className={containerClassName}>
    This site is protected by reCAPTCHA and the Google&nbsp;
    <a 
      href="https://policies.google.com/privacy"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-underline"
    >
      Privacy Policy
    </a>
    &nbsp;and&nbsp;
    <a
      href="https://policies.google.com/terms"
      target="_blank"
      rel="noopener noreferrer"
      className="text-decoration-underline"
    >
      Terms of Service
    </a>
    &nbsp;apply.
  </div>
);

CaptchaDisclaimer.propTypes = propTypes;
CaptchaDisclaimer.defaultProps = defaultProps;

export default CaptchaDisclaimer;
